export default "__VITE_ASSET__c3ed2162__"